import React from 'react';
import { Gift, Video, FileText } from 'lucide-react';

export const Bonus = () => {
  const bonuses = [
    {
      icon: <Video size={32} />,
      title: 'Exklusiv für die ersten 5 Premium-Kunden',
      description: 'Wöchentliches Video-Feedback zu deinen Übungen – damit du optimal Fortschritte machst.'
    },
    {
      icon: <Gift size={32} />,
      title: 'Gratis-Video',
      description: '"5 Gewohnheiten, die dein Leben verbessern" (Wert: 4,99€) – kostenlos für alle Teilnehmer.'
    },
    {
      icon: <FileText size={32} />,
      title: 'PDF-Guide inklusive',
      description: '"So sitzt und stehst du ohne Schmerzen" – sofort umsetzbare Tipps für deinen Alltag.'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Deine Bonusinhalte
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Zusätzliche Unterstützung, damit du noch schneller Ergebnisse siehst.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'var(--spacing-large)'
        }}>
          {bonuses.map((bonus, index) => (
            <div key={index} className="network-card" style={{
              textAlign: 'center',
              cursor: 'default',
              background: 'linear-gradient(135deg, var(--bg-card) 0%, var(--bg-subtle) 100%)'
            }}>
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {bonus.icon}
              </div>
              <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
                {bonus.title}
              </h3>
              <p className="body-medium">
                {bonus.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};